import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectorRef,
  ViewEncapsulation,
  ViewChild,
  Renderer2,
  OnDestroy,
  ElementRef,
} from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { Observable } from 'rxjs'
import { LaunchDialogService } from '@spartacus/storefront'
import { ShoppingCartService } from '../cart.service'
import { Actions, ofType } from '@ngrx/effects'
import { filter, map, take } from 'rxjs/operators'

import moment from 'moment'
import {
  MultiCartFacade,
  PromotionLocation,
  PromotionResult,
} from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { Discounts } from '../../../../models/discounts.model'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { ShoppingCart } from '../cart.model'
import {
  Ecommerce,
  EcommerceItem,
  GTMCartType,
  GTMDataLayer,
} from '../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../shared/services/gtm.service';

export interface Item {
  product?: any
  quantity?: any
  basePrice?: any
  totalPrice?: any
  netPrice?: any
  updateable?: boolean
  entryNumber?: any
  customerRequestedDate?: any
  assignedShipDate?: any
  selectedLegalEntity?: any
  availabilityDetail?: any
  splitByAvailability?: boolean
  stockAvailability?: boolean
  discountDetails?: any
  deliveryGroupNumber?: any
  customerMaterialNumber?: any
  materialAvailability?: any
  comment?: any
  salesConversion?: any
  salesUnit?: any
  availableAt?: any
  expressAdder?: any
  quoteCartEntryType?: string
  plantAvailableAt?: any
  expressAdderPercent?: any
  afterMarket?: any
  afterMarketPremium?: any
  minOrderQuantity?: any
}

export interface CartItemComponentOptions {
  isSaveForLater?: boolean
  optionalBtn?: any
}

// export enum Discounts {
//   ZRGD = 'Region Discount',
//   ZCUD = 'Customer Discount',
//   ZQSD = 'Product/Volume Discount',
//   ZLVD = 'Product/Volume Discount',
//   ZHVD = 'Product/Volume Discount',
//   ZSQD = 'Stock Order Discount',
//   ZSVD = 'Stock Order Discount',
//   ZSD1 = 'Manual Discount Adjustment',
//   ZSD2 = 'Manual Discount Adjustment',
//   ZDSH = 'Manual Adder Adjustment',
//   ZEDC = 'Express Delivery Adder',
//   ZDOA = 'Coupon',
// }

@Component({
  standalone: false,
  selector: 'vs-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CartItemComponent implements OnInit, OnDestroy {
  @Input() compact = false
  @Input() item: Item
  @Input() readonly = false
  @Input() quantityControl: FormControl = new FormControl('', [
    Validators.required,
  ])
  @Input() entryNum = 0
  @Input() totalEntries
  @Input() productOpen

  @Output() view = new EventEmitter<any>()

  @Output()
  selectedEntry: EventEmitter<any> = new EventEmitter()

  @Output()
  selectedMultipleEntry: EventEmitter<any> = new EventEmitter()

  @Input() promotionLocation: PromotionLocation = PromotionLocation.ActiveCart

  @Output()
  selectedLegalEntityId: EventEmitter<any> = new EventEmitter()

  // TODO: evaluate whether this is generic enough
  @Input() options: CartItemComponentOptions = {
    isSaveForLater: false,
    optionalBtn: null,
  }

  @Input()
  userType: string

  @Input()
  cart: ShoppingCart

  @Input()
  checkAll: boolean

  @ViewChild('viewBreakupLink')
  viewBreakupLink

  @ViewChild('breakupContent')
  breakupContent

  newItem: Item
  appliedProductPromotions$: Observable<PromotionResult[]>
  breakUp = false
  cartNumber = 0
  holidayList: any[] = []

  // userType = '';
  cartId = ''
  deleteCartDialog
  inventoryDialog
  minDate = new Date()
  quantity: FormControl = new FormControl(this.quantityControl.value, [
    Validators.required,
  ])
  showCheckAvalabilityAction = false
  checkAvailabilityError = false
  showAvailabilityLoader = false
  selectedLegalEntity: any = {
    code: '0',
    name: 'Select',
  }
  showCommentsInput = false
  consEntryErrorIndex = ''
  consEntryErrorSubscription: any
  showReqShipError = false
  savingComments = false

  deliGrpEntryErrorSubscription: any
  showDeliGrpError = false
  deliGrpErrorType = ''
  errorEntries = []
  commentError = false

  isPartialSubscription: any
  isShipmentPartial = false
  deliveryGroupNumber = ''
  deliveryGroupLoader = false
  showDiffPlantWarning = false

  mergeCartItemDialog
  msgText = ''
  selectedDay
  commentsSaved = false
  showCommentsNotSavedErr = false
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  dayOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]
  consolidatedShipError: boolean
  shippedFrmOptions: any[] = []
  otherInventoryLocations: any[] = []
  checkValue: any
  savingMaterialNum: boolean = false

  constructor(
    // protected promotionService: PromotionService,
    private launchDialogService: LaunchDialogService,
    private globalMessageService: GlobalMessageService,
    private multiCartFacade: MultiCartFacade,
    private shoppingCartService: ShoppingCartService,
    private actions$: Actions,
    private cRef: ChangeDetectorRef,
    private spinnerOverlayService: SpinnerOverlayService,
    private renderer: Renderer2,
    public elRef: ElementRef,
    private calenderConfigService: CalenderConfigService,
    private translate: TranslationService,
    private gtmService: GoogleTagManagerService
  ) {
    this.renderer.listen(document, 'click', this.bodyClick.bind(this))
  }

  ngOnInit() {
    /*  this.appliedProductPromotions$ = this.promotionService.getProductPromotionForEntry(
       this.item,
       this.promotionLocation
     ); */

    this.cartNumber = this.entryNum++
    this.productOpen = true
    this.cartId = this.cart.code
    this.quantity.setValue(this.item.quantity)
    this.onQtyChanges()
    this.newItem = Object.assign({}, this.item)
    if (this.cart.isConsolidatedShipment == true) {
      this.selectedDay = this.cart?.consolidatedDay?.toLowerCase().split(',')
      let custDate = new Date(this.newItem.assignedShipDate)
      let currentDate = this.dayOfWeek[custDate.getDay()]?.toLocaleLowerCase()

      if (this.selectedDay?.includes(currentDate)) {
        this.consolidatedShipError = false
        this.cRef.detectChanges()
      } else {
        this.consolidatedShipError = true
        this.cRef.detectChanges()
      }
    }

    this.msgText = ''
    this.shoppingCartService.isCheckAvailability$.subscribe((res) => {
      if (res.length > 0) {
        if (this.findProductFromCartItems(res).length > 0) {
          this.translate
            .translate('savedCart.errText3')
            .subscribe((res: string) => (this.msgText = res))
        }
      }
    })
    if (this.newItem?.stockAvailability === false) {
      this.translate
        .translate('savedCart.errText')
        .subscribe((res: string) => (this.msgText = res))
    }

    if (this.newItem?.splitByAvailability === true) {
      this.translate
        .translate('savedCart.errText2')
        .subscribe((res: string) => (this.msgText = res))
    }

    // this.msgText = '';
    if (this.newItem?.minOrderQuantity > this.newItem?.quantity) {
      this.translate
        .translate('savedCart.minOrderQuantity')
        .subscribe(
          (res: string) =>
            (this.msgText = res + ' ' + this.newItem?.minOrderQuantity)
        )
    }

    // this.newItem.defaultPlant = this.newItem.defaultPlant
    //   ? this.newItem.defaultPlant
    //   : this.selectedLegalEntity;
    this.newItem.plantAvailableAt.forEach((element) => {
      if (element.defaultPlant === true) {
        this.selectedLegalEntity = element
        this.selectedLegalEntityId = this.selectedLegalEntity.code
      }
      if (
        element.code == this.newItem?.selectedLegalEntity.uid ||
        element.code.slice(0, 3) ==
          this.newItem?.selectedLegalEntity.uid.slice(0, 3)
      ) {
        this.shippedFrmOptions.push(element)
      } else {
        // this.selectedLegalEntityId = undefined
        this.otherInventoryLocations.push(element)
      }
    })
    if (this.newItem.comment) {
      this.showCommentsInput = true
    }

    this.consEntryErrorSubscription =
      this.shoppingCartService.consCartEntryError$.subscribe(
        (res: []) => {
          if (res.length <= 0) {
            this.errorEntries = []
            this.showReqShipError = false
            this.cRef.detectChanges()
          }
          for (const item of res) {
            this.errorEntries = res
            if (item == this.newItem.entryNumber) {
              this.showReqShipError = true
              this.cRef.detectChanges()
            }
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    this.deliGrpEntryErrorSubscription =
      this.shoppingCartService.deliveryGrpCartEntryError$.subscribe(
        (res: any) => {
          if (res?.entryNumbers?.length <= 0) {
            this.showDeliGrpError = false
            this.cRef.detectChanges()
          }
          if (res && res.entryNumbers && res.entryNumbers.length > 0) {
            for (const item of res.entryNumbers) {
              if (item == this.newItem.entryNumber) {
                this.showDeliGrpError = true
                this.deliGrpErrorType = res.type
                this.cRef.detectChanges()
              }
            }
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    this.isPartialSubscription =
      this.shoppingCartService.isShippingTypePartial$.subscribe(
        (res) => {
          this.isShipmentPartial = res
          this.cRef.detectChanges()
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    this.deliveryGroupNumber = this.newItem.deliveryGroupNumber
      ? this.newItem.deliveryGroupNumber
      : ''
  }

  ngOnDestroy() {
    this.showReqShipError = false
    this.shoppingCartService.setConsErrors([])
    this.shoppingCartService.setDeliveryGroupErrors({})
    this.cRef.detectChanges()
    this.consEntryErrorSubscription.unsubscribe()
    this.deliGrpEntryErrorSubscription.unsubscribe()
    this.isPartialSubscription.unsubscribe()
  }

  materialInputChanges() {
    if (
      this.newItem.customerMaterialNumber.length >= 3 &&
      this.newItem.customerMaterialNumber.length <= 25
    ) {
      this.savingMaterialNum = true
      this.saveMaterialNumber(
        this.newItem.entryNumber,
        this.newItem.customerMaterialNumber
      )
    }
  }

  onSaveMaterialNumMouseDown(event) {
    if (event.which == 1) {
      event.preventDefault()
      this.materialInputChanges()
    }
  }

  saveMaterialNumber(entryNumber, material_number) {
    this.shoppingCartService
      .updateMaterialNumber(
        this.userType,
        this.cartId,
        entryNumber,
        material_number
      )
      .subscribe(
        (res) => {
          this.savingMaterialNum = false;
          this.cRef.detectChanges()
        },
        (error) => {
          this.savingMaterialNum = false;
          this.cRef.detectChanges()
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  isProductOutOfStock(product: any) {
    // TODO Move stocklevelstatuses across the app to an enum
    return (
      product &&
      product.stock &&
      product.stock.stockLevelStatus === 'outOfStock'
    )
  }

  removeItem() {
    this.quantityControl.setValue(0)
    this.quantityControl.markAsDirty()
  }

  gtmSelectItemEvent(Item) {
    if (Item) {
      let producitem: EcommerceItem[] = [];
      producitem.push({
        item_id: Item.product?.code,
        item_name: Item.product?.name,
        discount: Item?.discountPercentage ? +Item?.discountPercentage : '',
        index: Item?.entryNumber > -1 ? Item?.entryNumber : 0,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: Item?.discountPrice ? + Item?.discountPrice : '',
        quantity: Item.quantity
      });
      let purchaseEcommerceEcommerce: Ecommerce = {
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        items: producitem,
      };
      let selectItemDataLayer: GTMDataLayer = {
        event: GtmEvents.SelectItem,
        ecommerce: purchaseEcommerceEcommerce,
      };
      this.gtmService.sendEvent(selectItemDataLayer);
    }
  }

  viewItem(item) {
    this.gtmSelectItemEvent(item)
    this.view.emit()
  }

  onDateChange(e, flag) {
    if(flag == 'crd'){
      this.newItem.customerRequestedDate = moment(e).format('YYYY/MM/DD');
      this.saveCRDchange(this.newItem.entryNumber, this.newItem.customerRequestedDate);
    } else if(flag == 'psd'){
      this.showCheckAvalabilityAction = true;
      this.shoppingCartService.setCheckAvailabilityFlag(this.item, true);

      this.newItem.assignedShipDate = moment(e).format('YYYY/MM/DD');
      this.selectedMultipleEntry.emit({
        entry: this.newItem,
        checked: this.checkValue,
        plant: this.selectedLegalEntity,
      })
    }
  }

  saveCRDchange(entryNumber, customerRequestedDate) {
    this.spinnerOverlayService.show();
    this.shoppingCartService
      .updateCustomerReqDate(
        this.userType,
        this.cartId,
        entryNumber,
        customerRequestedDate
      )
      .subscribe(
        (res) => {
          this.multiCartFacade.loadCart({
            cartId: this.cartId,
            userId: this.userType,
            extraData: {
              active: true,
            },
          })
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            error.message,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

      this.actions$
      .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
      .subscribe(
        (success) => {
          this.spinnerOverlayService.hide()
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            error.message,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  onLegalEntitySelect(e) {
    if (e.code != this.selectedLegalEntity.code && !e.defaultPlant) {
      this.showDiffPlantWarning = true
    } else {
      this.showDiffPlantWarning = false
    }
    this.showCheckAvalabilityAction = true
    this.shoppingCartService.setCheckAvailabilityFlag(this.item, true)
    this.selectedMultipleEntry.emit({
      entry: this.newItem,
      checked: this.checkValue,
      plant: e,
    })
    this.selectedLegalEntityId = e.code
  }

  openDeleteDialog() {
    // this.OpenPopUp = !this.OpenPopUp;
    const componentdata = {
      cart: this.cart,
      userType: this.userType,
      cartId: this.cartId,
    }

    const deleteCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.DELETE_BUY_CART,
      undefined,
      undefined,
      componentdata
    )
    if (deleteCartDialog) {
      deleteCartDialog.subscribe((value) => {
        // if (value?.instance?.reason == 'delete-buy-cart') {
        //   this.deleteCartItem()
        // }
      })
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.DELETE_BUY_CART
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value.reason == 'delete-buy-cart') {
            this.deleteCartItem()
          }
        })
    }
  }

  deleteCartItem() {
    // this.OpenPopUp = false;
    this.spinnerOverlayService.show()
    this.multiCartFacade.removeEntry(
      this.userType,
      this.cartId,
      this.cartNumber
    )

    this.actions$
      .pipe(
        ofType(CartActions.CART_REMOVE_ENTRY_SUCCESS),
        map((action: CartActions.CartRemoveEntrySuccess) => action.payload)
      )
      .pipe(take(1))
      .subscribe(
        () => {
          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
            .pipe(take(1))
            .subscribe(
              (s) => {
                this.spinnerOverlayService.hide();
                this.removeItemEvent();
                this.globalMessageService.add(
                  { key: 'savedCart.removedSuccessfully' },
                  GlobalMessageType.MSG_TYPE_CONFIRMATION,
                  5000
                )
                window.scrollTo(0, 0)
              },
              (error) => {
                this.spinnerOverlayService.hide()
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              }
            )
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  removeItemEvent(){
    const removeFromCartDataLayer: GTMDataLayer = {
      event: GtmEvents.RemoveFromCart,
      ecommerce: {
        currency: this.item.netPrice?.currencyIso,
        value: this.item.totalPrice?.formattedValue,
        items: [
          {
            item_id: this.item.product.code,
            item_name: this.item.product.name,
            index: this.item.entryNumber,
            item_list_id: ItemListTypeEnum.Cart,
            item_list_name: ItemListTypeEnum.Cart,
            price: this.item.totalPrice?.formattedValue,
            quantity: this.item.quantity,
          },
        ],
      },
      commerceType: GTMCartType.BUY_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(removeFromCartDataLayer);
  }

  toggleProduct() {
    this.productOpen = !this.productOpen
  }

  onQtyChanges(): void {
    this.quantity.valueChanges.subscribe(
      (val) => {
        if (!Number.isInteger(val)) {
          val = Math.floor(val)
        }
        // this.quantityControl.setValue(val);
        this.newItem.quantity = val
        this.showCheckAvalabilityAction = true
        this.shoppingCartService.setCheckAvailabilityFlag(this.item, true)
        this.selectedMultipleEntry.emit({
          entry: this.newItem,
          checked: this.checkValue,
          plant: this.selectedLegalEntity,
        })
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  validateCheckAvailability() {
    const duplicateEntries = this.checkForDuplicateCartEntries(this.newItem)
    if (duplicateEntries.length > 0) {
      this.openMergeCartItemDialog(duplicateEntries)
      return
    } else {
      this.checkAvailability()
    }
  }

  checkAvailability() {
    this.shoppingCartService.setCartHeaderDate('');
    this.showAvailabilityLoader = true;
    this.newItem.quantity = (this.newItem.quantity <= 0) ? 1 : this.newItem.quantity;
    this.shoppingCartService
      .getCheckAvailability(
        this.newItem,
        this.cartId,
        this.userType,
        this.selectedLegalEntity
      )
      .subscribe(
        (res: any) => {
          if (res) {
            this.multiCartFacade.loadCart({
              cartId: res.code,
              userId: this.userType,
              extraData: {
                active: true,
              },
            });

            this.actions$
              .pipe(ofType(CartActions.LOAD_CART_SUCCESS))
              .pipe(take(1))
              .subscribe(
                (r) => {
                  this.showAvailabilityLoader = false
                  this.showCheckAvalabilityAction = false
                  this.shoppingCartService.setCheckAvailabilityFlag([], false)
                  if (this.errorEntries.length > 0) {
                    for (const e of this.errorEntries) {
                      if (e == this.item.entryNumber) {
                        this.errorEntries.splice(
                          this.errorEntries.indexOf(e),
                          1
                        )
                      }
                    }
                  }
                  this.shoppingCartService.setConsErrors(this.errorEntries);
                  this.showReqShipError = false;
                  this.cRef.detectChanges();
                },
                (error) => {
                  this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  )
                  window.scrollTo(0, 0)
                }
              )
          } else {
            this.checkAvailabilityError = true;
          }
          this.cRef.detectChanges();
        },
        (error: any) => {
          this.showAvailabilityLoader = false
          this.checkAvailabilityError = true
          this.cRef.detectChanges()
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  checkForDuplicateCartEntries(cartItem) {
    const duplicateEntries = []
    for (const en of this.cart.entries) {
      if (cartItem.entryNumber != en.entryNumber) {
        if (
          cartItem.customerRequestedDate == en.customerRequestedDate &&
          cartItem.selectedPlant?.code == this.selectedLegalEntity?.code
        ) {
          duplicateEntries.push(en.entryNumber)
        }
      }
    }
    return duplicateEntries
  }

  openMergeCartItemDialog(duplicateEntries) {
    const componentdata = {
      duplicateEntries: duplicateEntries,
      cartItem: this.newItem,
    }

    const mergeCartItemDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.MERGE_CART_ITEM,
      undefined,
      undefined,
      componentdata
    )
    if (mergeCartItemDialog) {
      mergeCartItemDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.MERGE_CART_ITEM
          ),
          take(1)
        )
        .subscribe((value) => {
          this.cRef.detectChanges()
        })
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.uid === c2.uid : c1 === c2
  }

  getDiscountName(code) {
    let discountName = Discounts[code]
    if (code.indexOf('Action') > -1) {
      discountName = 'Coupon'
    }
    return discountName
  }

  closeMenu(event) {
    this.breakUp = false
  }

  getTotalDiscounts(basePrice, netPrice) {
    let totalDisc = ''
    if (basePrice && netPrice) {
      totalDisc =
        basePrice.formattedValue[0] +
        (basePrice.value - netPrice.value).toFixed(2)
      /* for (const disc of discounts) {
        totalDisc += disc.value;
      } */
      // return discounts[0]?.formattedValue[0] + totalDisc.toFixed(2);
    }
    return totalDisc
  }

  splitItemByQty(){
    if(this.item.quantity > 1){
      let selectedItem = {
        ...this.item,
        quantity: 1,
        totalPrice: {
          ...this.item.totalPrice,
          value: Number(this.item.netPrice.value),
          formattedValue: "$" + this.item.netPrice.value.toFixed(2)
        }
      }

      this.splitItemEntry();
    }
  }

  splitItemEntry() {
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .splitItemEntry(this.userType, this.cartId, this.item.entryNumber)
      .subscribe(
        (res) => {
          this.multiCartFacade.loadCart({
            cartId: this.cartId,
            userId: this.userType,
            extraData: {
              active: true,
            },
          })
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    this.actions$
      .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
      .subscribe(
        (success) => {
          this.spinnerOverlayService.hide()
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  splitEntry() {
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .splitCartEntry(this.userType, this.cartId, this.item.entryNumber)
      .subscribe(
        (res) => {
          this.multiCartFacade.loadCart({
            cartId: this.cartId,
            userId: this.userType,
            extraData: {
              active: true,
            },
          })
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    this.actions$
      .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
      .subscribe(
        (success) => {
          this.spinnerOverlayService.hide()
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  checkEntry(event: any) {
    this.checkValue = event.target.checked
    this.selectedEntry.emit({
      entryNumber: this.item.entryNumber,
      checked: this.checkValue,
    })
    this.selectedMultipleEntry.emit({
      entry: this.newItem,
      checked: this.checkValue,
      plant: this.selectedLegalEntity,
    })
  }

  onCommentsInputBlur(event) {
    if (!this.commentsSaved && this.newItem.comment?.length >= 0) {
      this.showCommentsNotSavedErr = true
    }
  }

  onSaveCommentsMouseDown(event) {
    if (event.which == 1) {
      event.preventDefault()
      this.saveComments()
    }
  }

  saveComments() {
    if (!this.newItem.comment || this.newItem.comment?.length <= 0) {
      this.commentError = true
      return
    } else {
      this.commentError = false
    }
    this.savingComments = true
    this.shoppingCartService
      .addCartItemComments(
        this.userType,
        this.cartId,
        this.newItem.entryNumber,
        this.newItem.comment
      )
      .subscribe(
        (res) => {
          this.commentsSaved = true
          this.showCommentsNotSavedErr = false
          this.savingComments = false
          this.cRef.detectChanges()
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  onDeliveryGroupInputBlur() {
    /* if (this.newItem.deliveryGroupNumber == this.deliveryGroupNumber) {
      return;
    } */
    const oldDeliGroup = this.newItem.deliveryGroupNumber
    if (this.deliveryGroupNumber.length <= 0) {
      this.showDeliGrpError = true
      this.deliGrpErrorType = '100'
      return
    }
    this.newItem.deliveryGroupNumber = this.deliveryGroupNumber

    let errors: any = {}
    errors = this.shoppingCartService.checkPromisedShipDateMismatch(
      this.cart.entries,
      this.newItem
    )

    if (!errors || errors.entryNumbers.length <= 0) {
      errors = this.shoppingCartService.checkLegalEntityMismatch(
        this.cart.entries,
        this.newItem
      )
    }

    if (errors?.entryNumbers.length > 0) {
      errors.entryNumbers.push(this.newItem.entryNumber)
      this.deliveryGroupNumber = oldDeliGroup
      this.newItem.deliveryGroupNumber = this.deliveryGroupNumber
    }
    this.shoppingCartService.setDeliveryGroupErrors(errors)

    if (errors.entryNumbers.length <= 0) {
      const cartInput = {
        entries: [this.newItem],
      }
      this.deliveryGroupLoader = true
      this.shoppingCartService
        .addDeliveryGroups(this.userType, this.cartId, cartInput)
        .subscribe(
          (sucess) => {
            this.deliveryGroupLoader = false
            this.multiCartFacade.loadCart({
              userId: this.userType,
              cartId: this.cartId,
              extraData: {
                active: true,
              },
            })
          },
          (error) => {
            this.globalMessageService.add(
              error,
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  getAvailableQuantity(qty) {
    for (const availDetail of this.item.availabilityDetail) {
      if (
        moment(availDetail.committedDate).format('DD-MM-YYYY') ==
        moment(this.item.customerRequestedDate).format('DD-MM-YYYY')
      ) {
        return Number(availDetail.committedQuantity)
      }
    }
    return Number(qty)
  }

  // getEarliestPossibleDate(avail) {
  //   if (
  //     moment(avail.committedDate).format('DD-MM-YYYY') ==
  //     moment(this.item.customerRequestedDate).format('DD-MM-YYYY')
  //   ) {
  //     return false
  //   }
  //   return true
  // }

  getEarliestPossibleDate(avail) {
    if (!(moment(avail.committedDate).isSame(moment(this.item.assignedShipDate), 'day')) && (this.item?.materialAvailability == 'Y')) {
      return true;
    } else{
      return false;
    }
  }

  findProductFromCartItems(items) {
    return items.filter((el) => {
      return (
        el.product.code == this.newItem.product.code &&
        el.entryNumber == this.newItem.entryNumber
      )
    })
  }

  bodyClick() {
    if (
      this.viewBreakupLink &&
      !this.viewBreakupLink.nativeElement.contains(event.target) &&
      this.breakupContent &&
      !this.breakupContent.nativeElement.contains(event.target)
    ) {
      this.breakUp = false
      this.cRef.detectChanges()
    }
  }
  viewInventory() {
    const componentdata = {
      product: this.otherInventoryLocations,
    }

    const inventoryDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.VIEW_INVENTORY,
      undefined,
      undefined,
      componentdata
    )
    if (inventoryDialog) {
      inventoryDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }
}
